import { Component, OnInit } from '@angular/core';
import { EmployeeService } from '../services/employee.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-employee',
  templateUrl: './employee.component.html',
  styleUrls: ['./employee.component.css']
})
export class EmployeeComponent {


  isSavingInfo: boolean = false;
  successMessage: string = "";

  showAddEmployeeModal: boolean = false;


  constructor(private route: ActivatedRoute, private router: Router, private employeeService: EmployeeService) { }

  ngOnInit(){
  }

  searchEmployees = async (term: string): Promise<TypeaheadOption[]> => {
    let result = this.employeeService.searchEmployee("employee", term).toPromise();
    return result;
  }

  async handleEmployeeSelect(employee: any){
    this.router.navigate([`/employees/${employee.sid}/details`]);
  }
}
